import { useEnum } from "@/api/services/global/enum";
import { Tag, TTagVariant } from "@/modules/irohana-components/elements/Tag";
import { EMPTY_STR } from "@/constants/string";
import { background, black, state, text } from "@/theme/colors";
import { EOrganizationContractStatus, TOrganizationContractStatus } from "@/types/enum";
import { findLabelByValue } from "@/utils/object";
import { FC, useMemo } from "react";

export type TOrganizationStatusTagProps = {
  status: TOrganizationContractStatus;
  variant?: TTagVariant;
};

export const OrganizationStatusTag: FC<TOrganizationStatusTagProps> = ({ status, variant = "bold" }) => {
  const { data: statusOptions } = useEnum("EOrganizationContractStatus");

  const colorTagProps = useMemo(() => {
    if (status === EOrganizationContractStatus.DURING_CONTRACT) {
      return { color: state.success_2, pointColor: state.success_1 };
    }
    if (status === EOrganizationContractStatus.CANCELED_CONTRACT) {
      return { color: state.error_2, pointColor: state.error_1 };
    }
    if (status === EOrganizationContractStatus.TRIAL) {
      return { color: state.warning_1, pointColor: state.warning_1 };
    }
    if (status === EOrganizationContractStatus.TRIAL_CANCELLED) {
      return { color: background.disable, pointColor: black[80] };
    }

    return { color: background.disable };
  }, [status]);

  return <Tag variant={variant} title={findLabelByValue(statusOptions, status) || EMPTY_STR.TEXT} {...colorTagProps} textColor={text.primary} />;
};
